import styled from "styled-components"
import { DashboardCards } from "../styled/CustomCard"
import ProductListItem from "./ProductListItem"

const PLACEHOLDER_IMG =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><rect width="100" height="100" fill="#eee"/><text x="50" y="50" text-anchor="middle" dy=".3em" fill="#999" font-size="12">No image</text></svg>'
  )

const TopProduct = styled.div`
  font-weight: bold;
  background-color: #eee;
  padding: 1.5rem;
  align-items: center;
  border-bottom: 1px solid #eee;

  span {
    font-weight: normal;
    font-size: 1rem;
    display: block;
    padding-left: 1em;
  }

  img {
    width: 100%;
    max-height: 120px;
    object-fit: cover;
  }
`

const Labels = styled.div`
  font-size: small;
  color: #999;
  padding-bottom: 0.5rem;
`

const ProductList = styled.div`
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem;

  .row {
    border-bottom: 1px solid #eee;
    padding: 1.5rem 0.5rem;
  }
`

type SalesClaimMadeOnProduct = {
  productImage?: string
  productName: string
  salesClaimMadeCount: number
}

type Props = {
  TopSKUs: SalesClaimMadeOnProduct[]
}

const TopSKUsCard = ({ TopSKUs }: Props) => {
  const topSkus = TopSKUs ?? []

  return (
    <div className="container-fluid h-100">
      <DashboardCards>
        <div className="row border-bottom">
          <div className="col">
            <h6>Top Categories</h6>
          </div>
        </div>
        <div className="row">
          <div className="col-6 pt-2 border-end">
            <Labels>
              <div className="row">
                <div className="col">Product</div>
                <div className="col text-end">Sales Claims Made</div>
              </div>
            </Labels>
            <TopProduct>
              <div className="row">
                <div className="col-3">
                  <img
                    src={
                      topSkus[0]?.productImage
                        ? topSkus[0].productImage
                        : PLACEHOLDER_IMG
                    }
                    alt={topSkus[0]?.productName ?? "Product"}
                  />
                </div>
                <div className="col-6">
                  1. {topSkus[0]?.productName}
                </div>
                <div className="col-3 text-end">
                  {topSkus[0]?.salesClaimMadeCount}
                </div>
              </div>
            </TopProduct>
            <ProductList>
              {topSkus.slice(1, 3).map(
                (salesClaims: SalesClaimMadeOnProduct, index: number) => (
                  <ProductListItem
                    productImage={salesClaims?.productImage}
                    productName={salesClaims?.productName}
                    claimsMade={salesClaims?.salesClaimMadeCount}
                    key={index}
                    rank={index + 2}
                  />
                )
              )}
            </ProductList>
          </div>

          <div className="col-6 pt-2">
            <Labels>
              <div className="row">
                <div className="col">Product</div>
                <div className="col text-end">Sales Claims Made</div>
              </div>
            </Labels>
            <ProductList>
              {topSkus.slice(3, 6).map(
                (salesClaims: SalesClaimMadeOnProduct, index: number) => (
                  <ProductListItem
                    productImage={salesClaims?.productImage}
                    productName={salesClaims?.productName}
                    claimsMade={salesClaims?.salesClaimMadeCount}
                    key={index}
                    rank={index + 4}
                  />
                )
              )}
            </ProductList>
          </div>
        </div>
      </DashboardCards>
    </div>
  )
}

export default TopSKUsCard
